import Monitoring from 'shared_modules/Monitoring';

const config = {
  debug: false,
  newrelic: true,
};

interface TrackErrorInput {
  description?: string;
  error: Error;
  flashNotifier?: boolean;
  showNotifier?: boolean;
}

const trackError = (errorObj: TrackErrorInput) => {
  const { debug, newrelic } = config;

  if (debug) {
    console.log(errorObj); // eslint-disable-line no-console
  }

  if (newrelic) {
    const { error } = errorObj;
    Monitoring.addError(error);
  }

  if (errorObj.flashNotifier) {
    window.flashNotifier?.('warning', errorObj.description, 3);
  }

  if (errorObj.showNotifier) {
    window.showNotifier?.('warning', errorObj.description);
  }
};

export default trackError;
